import React from 'react';
import { Strong } from 'evergreen-ui';
import { Link } from 'react-router-dom';
import { PROFILE } from 'Features/routePaths';
import { getStationPath, StationProps } from './utils';

export function StationName({ station }: StationProps) {
  return (
    <Strong
      is={Link}
      to={`${getStationPath(station.id)}/${PROFILE}`}
      size={400}
      color="rgb(16, 112, 202)"
    >
      {`[ ${station.idx} ] ${station.name}`}
    </Strong>
  );
}
export const MemoStationName = React.memo(StationName);
MemoStationName.displayName = 'MemoStationName';
export default StationName;
